import React from 'react';
import './BTMenu.css';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export default class BTMenu extends React.Component {
    constructor() {
        super();
        this.list = null;
        this.state = {
            scrollHeight: null,
        };
    }

    componentDidMount() {
        // console.log('BTMenu componentDidMount');
        let value = this.checkForWrap();
        if (this.props.onResize) this.props.onResize(value);
        window.addEventListener('resize', this.onResize, true);
        this.onResize();
    }
    checkForWrap = () => {
        // console.log('BTMenu checkForWrap',this);
        let scrollHeight = this.list.scrollHeight;
        let width = this.list.clientWidth;
        let clientHeight = this.list.clientHeight;
        // console.log('BTMenu checkForWrap', width);
        this.setState({
            width,
        });
        return scrollHeight !== clientHeight;
    };

    onResize = () => {
        // console.log('BTMenu onResize event');
        let value = this.checkForWrap();
        // console.log('BTMenu onResize', value);
        if (this.props.onResize) this.props.onResize(value);
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize, true);
    }

    render() {
        let className = classNames('btp-menu', this.props.className);
        let childrenWithProps = React.Children.map(this.props.children, child => {
            return React.cloneElement(child, { width: this.state.width });
        });
        return (
            <ul ref={el => (this.list = el)} className={className} style={this.props.style}>
                {childrenWithProps}
            </ul>
        );
    }
}

BTMenu.propTypes = {
    onResize: PropTypes.func,
    style: PropTypes.object,
    className: PropTypes.string,
};

class Item extends React.Component {
    constructor() {
        super();
        this.offsetTop = 0;
    }
    componentDidMount() {
        if (this.props.id) {
            this.checkMe();
        }
    }

    componentWillReceiveProps(nexProps) {
        // console.log('Item componentWillReceiveProps',nexProps.id, this.props.width, nexProps.width)
        if (nexProps.id && this.offsetTop !== this.item.offsetTop) {
            this.checkMe();
        }
    }

    checkMe = () => {
        setTimeout(() => {
            let value = true;
            this.offsetTop = this.item.offsetTop;
            if (this.item.offsetTop > 0) {
                value = false;
            }
            if (this.props.onChangeVisibility && this.props.id) {
                let callback = { [this.props.id]: value };
                this.props.onChangeVisibility(callback);
            }
        }, 30); // dirty hack because after rotation on mobile this item still does not move to the next row becouse of the slow render
    };

    render() {
        let className = classNames('btp-menu-item', this.props.className);
        return (
            <li ref={el => (this.item = el)} className={className}>
                {this.props.children}
            </li>
        );
    }
}

Item.propTypes = {
    style: PropTypes.object,
    className: PropTypes.string,
    onChangeVisibility: PropTypes.func,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

BTMenu.Item = Item;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/AppMenu/BTMenu.js